import Select, { components } from "react-select";

const Option = (props, className) => {
  return (
    <div>
      <components.Option {...props}>
        <div className="flex items-center space-x-2">
          <input
            className={`flex flex-col items-center space-x-2 hover:bg-white${className}`}
            type="checkbox"
            checked={props.isSelected}
            onChange={() => null}
          />
          <label className="">{props.label}</label>
        </div>
      </components.Option>
    </div>
  );
};
const customStyles = {
  multiValueRemove: (provided) => ({
    ...provided,
    display: "none",
  }),
  multiValue: (provided) => ({
    ...provided,
    textOverflow: "ellipsis",
    maxWidth: "100px",
    whiteSpace: "nowrap",
    overflow: "hidden",
    display: "initial",
    backgroundColor: "transparent",
    padding: "0px",
  }),
  option: (provided, state) => ({
    ...provided,
    active: "",
    padding: "3px",
    color: "black",
    backgroundColor: "white",
    fontSize: "12px",
  }),

  control: (provided, state) => ({
    ...provided,
    background: "#fff",
    borderColor: "#d1d5db",
    minHeight: "29px",
    height: "29px",
    //boxShadow: state.isFocused ? null : null,
  }),

  valueContainer: (provided, state) => ({
    ...provided,
    fontSize: "13px",
    height: "29px",
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    width: "100%"
  }),

  input: (provided, state) => ({
    ...provided,
    margin: "0px",
  }),
  // indicatorSeparator: (state) => ({
  //   display: "none",
  // }),
  indicatorsContainer: (provided, state) => ({
    ...provided,
    height: "29px",
    margin: "0px",
  }),

  menu: (provided, state) => ({
    ...provided,
    overflowX: "auto",
    paddingLeft: "10px",
    overflow: "auto",
  }),
};

const valueContainer = ({ children, ...props }) => {
  let [values, input] = children;
  if (Array.isArray(values)) {
    values = values.length > 1 ? `Selected (${values.length}) ` : values;
  }

  return (
    <components.ValueContainer {...props}>
      {values}
      {input}
    </components.ValueContainer>
  );
};
const MultiSelectInput = ({
  options = [],
  value,
  handleMultiSelect,
  defaultValue,
  isDisabled = false,
  className = "sm:w-24 md:w-24 lg:w-full",
}) => {
  return (
    <div>
      <Select
        menuPortalTarget={document.body}
        value={value}
        className={`${className}`}
        defaultValue={defaultValue}
        options={options}
        onChange={handleMultiSelect}
        // onChange={handleMultiCarriersSelect}
        closeMenuOnSelect={false}
        isMulti
        isSearchable
        hideSelectedOptions={false}
        styles={customStyles}
        isDisabled={isDisabled}
        components={{
          ValueContainer: valueContainer,
          Option,
        }}
        tabSelectsValue={false}
      />
    </div>
  );
};
export default MultiSelectInput;
